import { createSelector } from 'reselect';
import { selectQuery } from '../location/selectors';

export const selectPortalAdmin = (state) => state.PortalAdmin;

export const selectInstitution = createSelector(selectQuery, (query) =>
  query.get('institution').toLowerCase()
);

export const selectPortalAdminData = createSelector(
  [selectPortalAdmin, selectInstitution],
  (admin, institution) => {
    if (admin) {
      return admin.get(institution);
    } else {
      return null;
    }
  }
);
